import React from 'react';
import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';

import WebformWrapper from '../../../../../components/Webform/Wrapper';
import WysiwygField from '../../../../../components/WysiwygField';

import '../style.scss';

const ParagraphCTAGetStarted = ({ entity }) => {
  const body = entity.getIn(['field_body', 0, 'processed']);
  const linkHref = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const webform = entity.getIn(['field_webform', 0, 'target_id']);

  return (
    <Container className="Paragraph ParagraphCTA ParagraphCTA--variant--get-started">
      <div className="row">
        <div className="col-12">
          <div className="ParagraphCTA__inner">
            <div className="ParagraphCTA__body">
              <WysiwygField
                property="schema:text"
                html={body}
                className="subheading2"
              />
            </div>
            {webform && webform !== 'webform_' && (
              <WebformWrapper id={webform} />
            )}
            <Button href={linkHref} className="Button--primary">
              {linkTitle}
              <div className="icon icon-chevron-right icon-variant-2" />
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphCTAGetStarted;
